'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { PriceListCompany } from './price-list-company';
import { PriceListAgency } from './price-list-agency';
import { PriceListStudent } from './price-list-student';

export const PriceListWrapper = () => {
  const [selectedForm, setSelectedForm] = useState('company');
  const { t } = useTranslations();
  const searchParams = useSearchParams();

  useEffect(() => {
    searchParams.get('type');
    if (searchParams.get('type') === 'jobseeker') {
      setSelectedForm('jobSeeker');
    }
  }, []);

  const options = [
    { id: 'company', label: t('text1432') },
    { id: 'agency', label: 'Vzdelávacia agentúra' },
    { id: 'jobSeeker', label: 'Uchádzač o zamestnanie' },
  ];

  return (
    <Container>
      <div className="ea-register-wrapper flex flex-col gap-4 py-6 md:gap-6 md:py-8">
        <h1 className="text-center text-3xl font-bold md:text-5xl">{t('text2228')}</h1>
        <div className="flex w-full flex-col gap-4 rounded-lg bg-white p-4 md:flex-row">
          {options.map(option => (
            <label
              key={option.id}
              className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-lg px-4 py-3 ${
                selectedForm === option.id ? 'bg-primary/10 text-black' : ''
              }`}
            >
              <input
                type="radio"
                name="registrationType"
                value={option.id}
                checked={selectedForm === option.id}
                onChange={() => setSelectedForm(option.id)}
                className="hidden" // Hide default radio button
              />
              <span
                className={`inline-block h-5 w-5 flex-shrink-0 rounded-full ${
                  selectedForm === option.id ? 'border-[6px] border-blue-500' : 'border-2'
                }`}
              />
              {option.label}
            </label>
          ))}
        </div>
        {selectedForm === 'company' && <PriceListCompany />}
        {selectedForm === 'agency' && <PriceListAgency />}
        {selectedForm === 'jobSeeker' && <PriceListStudent />}
      </div>
    </Container>
  );
};
